import React, { useState, useContext, useEffect } from 'react'
import RateContext from '../contexts/RateContext'

export default function SurvayItem(props) {


  useEffect(() => {

    setSelected(props.selected)

  }, [])
  let context = useContext(RateContext)
  const [selected, setSelected] = useState(false)

  let toggle = () => {
    if (props.disabled) {
      setSelected(!selected)
      if (!selected) {
        context.addRate(props.obj)
      } else {
        context.removeRate(props.obj)
      }
    }
  }

  return (
    <>
      <div
        className={
          selected
            ? 'btn d-flex justify-content-center align-items-center bg-primary text-white px-1 py-1 w-100'
            : 'btn d-flex justify-content-center align-items-center bg-light border border-primary rounded px-1 py-1 w-100'
           
        }
        onClick={toggle}
      >
        <span><small>{props.obj.rName}</small></span>
      </div>
    </>
  )
}
